import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Textarea,
  VStack,
  Box,
  Text,
} from "@chakra-ui/react";
import React from "react";

interface CancelAppointmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  cancelReason: string;
  setCancelReason: (value: string) => void;
  onConfirm: () => void;
  isProcessing: boolean;
}

const CancelAppointmentModal: React.FC<CancelAppointmentModalProps> = ({
  isOpen,
  onClose,
  cancelReason,
  setCancelReason,
  onConfirm,
  isProcessing,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
    >
      <ModalOverlay />
      <ModalContent
        mx={{ base: 3, sm: 4 }}
        maxW={{ base: "95vw", sm: "90vw", md: "md", lg: "lg" }}
      >
        <ModalHeader
          fontSize={{ base: "lg", sm: "xl" }}
          px={{ base: 4, sm: 6 }}
          py={{ base: 3, sm: 4 }}
        >
          Cancel Appointment
        </ModalHeader>
        <Box borderBottom="1px solid #E7E8EB" />
        <ModalBody px={{ base: 4, sm: 6 }} py={{ base: 4, sm: 5 }}>
          <VStack spacing={4} align="stretch">
            <Text
              fontSize={{ base: "sm", sm: "md" }}
              textAlign={{ base: "center", sm: "left" }}
            >
              Please provide a reason for cancellation:
            </Text>
            <Textarea
              placeholder="Enter reason for cancellation..."
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              minH={{ base: "80px", sm: "100px" }}
              fontSize={{ base: "sm", sm: "md" }}
              _hover={{ borderColor: "#DC3611" }}
              _focus={{
                borderColor: "#DC3611",
                boxShadow: "0 0 0 1px #DC3611",
              }}
            />
          </VStack>
        </ModalBody>
        <Box borderBottom="1px solid #E7E8EB" />
        <ModalFooter
          px={{ base: 4, sm: 6 }}
          py={{ base: 3, sm: 4 }}
          flexDirection={{ base: "column", sm: "row" }}
          gap={{ base: 3, sm: 0 }}
        >
          <Button
            variant="ghost"
            width={{ base: "full", sm: "auto" }}
            onClick={onClose}
            isDisabled={isProcessing}
            size={{ base: "sm", sm: "md" }}
            fontSize={{ base: "sm", sm: "md" }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={onConfirm}
            isLoading={isProcessing}
            loadingText="Cancelling..."
            width={{ base: "full", sm: "auto" }}
            size={{ base: "sm", sm: "md" }}
            fontSize={{ base: "sm", sm: "md" }}
            ml={{ base: 0, sm: 3 }}
          >
            Confirm Cancellation
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CancelAppointmentModal;
